<div class="gpd-tabbed-page">
  <nav class="gpd-page-tabs">
    <a *ngFor="let tab of tabs" class="gpd-page-tab" [routerLink]="tab.routerLink" routerLinkActive="active">
      {{ tab.label }}
    </a>
  </nav>
  <div class="gpd-tabbed-page-content general-config-content">
    <router-outlet></router-outlet>
  </div>
</div>